import { default as defaultExport } from "@cloudflare/unenv-preset/node/console";
globalThis.console = defaultExport;